"use client";
import Image from "@/components/Image";

const Partner = () => {
  return (
    <section className="w-full">
      <div className="w-full relative px-[80px] [@media(min-width:769px)_and_(max-width:1080px)]:px-[40px] [@media(max-width:768px)]:px-[20px]">
        {/* 背景图片 - 桌面端 */}
        <div className="hidden md:block absolute inset-0 -z-10 w-full h-full">
          <Image
            src="/partner_bg_07.jpg"
            alt="背景图片"
            fill
            className="object-cover"
          />
        </div>

        {/* 背景图片 - 移动端 */}
        <div className="block md:hidden absolute inset-0 -z-10 w-full h-full">
          <Image
            src="/bg_768_7.png"
            alt="背景图片"
            fill
            className="object-cover"
          />
        </div>

        <div className="w-full max-w-[1360px] mx-auto pt-[90px] flex flex-col gap-[66px]">
          <div className="w-full flex flex-col bg-auto gap-[20]">
            <div className="font-semibold text-[46px] [@media(min-width:415px)_and_(max-width:660px)]:text-[40px] [@media(max-width:414px)]:text-[clamp(2rem,9vw,2.5rem)] leading-[52px] tracking-[0px] text-center text-white">
              他们都选择蜜蜂家校
            </div>
            <div className="font-normal text-[18px] [@media(max-width:660px)]:text-[14px] leading-[28px] tracking-[2px] text-center text-white">
              蜜蜂家校始终致力于 AI 技术赋能教与学
            </div>
          </div>
          <div className="w-full flex flex-row bg-[#00000033]">
            <div className="w-full h-[239px] pt-[80px] hover:bg-[#1DBA55]">
              <div className="h-full w-full flex flex-col justify-start items-center gap-[24px]">
                <div className="font-normal text-[38px] [@media(max-width:660px)]:text-[24px] leading-[38px] tracking-[2px] text-center text-white">
                  数十万
                </div>
                <div className="font-normal mx-[12px] text-[16px] [@media(max-width:660px)]:text-[10px] leading-[18px] tracking-[2px] [@media(max-width:414px)]:tracking-[1px] text-center text-white">
                  累计覆盖数十万班级
                </div>
              </div>
            </div>
            <div className="w-full h-[239px] pt-[80px] hover:bg-[#1DBA55]">
              <div className="h-full w-full flex flex-col justify-start items-center gap-[24px]">
                <div className="font-normal text-[38px] [@media(max-width:660px)]:text-[24px] leading-[38px] tracking-[2px] text-center text-white">
                  数千万
                </div>
                <div className="font-normal mx-[12px] text-[16px] [@media(max-width:660px)]:text-[10px] leading-[18px] tracking-[2px] [@media(max-width:414px)]:tracking-[1px] text-center text-white">
                  累计处理超数千万份作业
                </div>
              </div>
            </div>
            <div className="w-full h-[239px] pt-[80px] hover:bg-[#1DBA55]">
              <div className="h-full w-full flex flex-col justify-start items-center gap-[24px]">
                <div className="font-normal text-[38px] [@media(max-width:660px)]:text-[24px] leading-[38px] tracking-[2px] text-center text-white">
                  数百万
                </div>
                <div className="font-normal mx-[12px] text-[16px] [@media(max-width:660px)]:text-[10px] leading-[18px] tracking-[2px] [@media(max-width:414px)]:tracking-[1px] text-center text-white">
                  注册用户累计超数百万
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="w-full py-[100px] [@media(max-width:414px)]:py-[70px] px-[80px] [@media(min-width:415px)_and_(max-width:768px)]:px-[40px] [@media(max-width:414px)]:px-[20px] bg-[#EDF3F7] flex flex-col items-center">
        <div className="max-w-[1360px] grid grid-cols-3 [@media(max-width:768px)]:grid-cols-2 gap-[50px] [@media(max-width:768px)]:gap-[24px]">
          <Image
            src="/shanghai_07.png"
            alt="上海师范大学附属第五嘉定实验学校"
            width={302.5}
            height={122}
            className="[@media(max-width:768px)]:"
          />
          <Image
            src="/shenzhen_07.png"
            alt="深圳明德实验学校"
            width={302.5}
            height={122}
          />
          <Image
            src="/binjiang_07.png"
            alt="滨江学校"
            width={302.5}
            height={122}
            className="[@media(max-width:768px)]:col-span-2 [@media(max-width:768px)]:justify-self-center object-center [@media(max-width:768px)]:w-[clamp(127px,40vw,302.5px)]"
          />
        </div>
      </div>
    </section>
  );
};
export default Partner;
